
import { Component, Vue } from 'vue-property-decorator'
import QueryString from 'query-string'
import Career from './components/career.vue'
import NewsList from './components/newsList.vue'
import Details from './components/details.vue'
import RepeatList from './components/repeatList.vue'
import { ReporterService } from '@/services/index'
import { AppModule } from '@/store/modules/app'

const WORK_STATUS = {
    Work: 1,
    Quit: 2
}

@Component({
    name: 'ReporterDetail',
    components: {
        Career,
        NewsList,
        Details,
        RepeatList
    }
})
export default class extends Vue {
    private activeTab = 'details'
    private reporterId = 0
    private reporter: any = {}
    private loading = true
    private typeOptions = [
        { value: 0, label: '记者' },
        { value: 1, label: '特邀记者' },
        { value: 2, label: '通讯员' },
        { value: 3, label: '投稿作者' },
        { value: 4, label: '实习生' }
    ]

    get workStatus() {
        return this.reporter.work_status === WORK_STATUS.Quit ? '离职' : '在职'
    }

    private async mounted() {
        const parsed: any = QueryString.parse(location.search)
        this.activeTab = parsed.tab ? parsed.tab : 'details'
        this.reporterId = parseInt(this.$route.params.id)
        this.$title('Loading | 记者详情 - 庖丁')
        await AppModule.getRegion()
        this.getReporter()
    }

    private async getReporter() {
        this.loading = true
        const result = await ReporterService.getDetail({ id: this.reporterId })
        this.loading = false
        if (result.status === 200) {
            this.reporter = result.data
            const { name, media } = result.data
            this.$title(`${name} ${media.name} | 记者详情 - 庖丁`)
        }
    }

    private onSwitchTab(tab: any) {
        this.activeTab = tab.name
        const url = this.$route.path + `?tab=${this.activeTab}`
        history.pushState('', '', url)
    }

    private onGoMediaBeer(rid: number) {
        window.open(`https://media.beer/reporter/${rid}`, '_blank')
    }

    private async updateReporter(type: number) {
        const params = { ...this.reporter, type }
        const result = await ReporterService.update(params)
        if (result.status === 200) {
            this.reporter.type = type
            return this.$msuccess('修改成功')
        }
        this.$merror(result.message || '发生错误, 请稍后再试')
    }
}
